/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiBatch } from './InternalApiBatch';
import {
    InternalApiBatchFromJSON,
    InternalApiBatchFromJSONTyped,
    InternalApiBatchToJSON,
    InternalApiBatchToJSONTyped,
} from './InternalApiBatch';

/**
 * 
 * @export
 * @interface InternalApiBatchPage
 */
export interface InternalApiBatchPage {
    /**
     * 
     * @type {number}
     * @memberof InternalApiBatchPage
     */
    number: number;
    /**
     * 
     * @type {number}
     * @memberof InternalApiBatchPage
     */
    size: number;
    /**
     * 
     * @type {number}
     * @memberof InternalApiBatchPage
     */
    total: number;
    /**
     * 
     * @type {Array<InternalApiBatch>}
     * @memberof InternalApiBatchPage
     */
    content: Array<InternalApiBatch>;
}

/**
 * Check if a given object implements the InternalApiBatchPage interface.
 */
export function instanceOfInternalApiBatchPage(value: object): value is InternalApiBatchPage {
    if (!('number' in value) || value['number'] === undefined) return false;
    if (!('size' in value) || value['size'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('content' in value) || value['content'] === undefined) return false;
    return true;
}

export function InternalApiBatchPageFromJSON(json: any): InternalApiBatchPage {
    return InternalApiBatchPageFromJSONTyped(json, false);
}

export function InternalApiBatchPageFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiBatchPage {
    if (json == null) {
        return json;
    }
    return {
        
        'number': json['number'],
        'size': json['size'],
        'total': json['total'],
        'content': ((json['content'] as Array<any>).map(InternalApiBatchFromJSON)),
    };
}

export function InternalApiBatchPageToJSON(json: any): InternalApiBatchPage {
    return InternalApiBatchPageToJSONTyped(json, false);
}

export function InternalApiBatchPageToJSONTyped(value?: InternalApiBatchPage | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'number': value['number'],
        'size': value['size'],
        'total': value['total'],
        'content': ((value['content'] as Array<any>).map(InternalApiBatchToJSON)),
    };
}

